<template>
  <div>
    <MobileUserProfile :menuItems="menuItems" v-if="$vuetify.breakpoint.smAndDown" />
    <DesktopUserProfile :menuItems="menuItems" v-else />
  </div>
</template>

<script>
import MobileUserProfile from './components/MobileUserProfile.vue'
import DesktopUserProfile from './components/DesktopUserProfile.vue'

export default {
  name: 'MinhaConta',
  components: {
    MobileUserProfile,
    DesktopUserProfile
  },
  data() {
    return {
      menuItems: [
        {
          icon: 'mdi-card-account-details-outline',
          title: 'Dados cadastrados',
          route: 'meus-dados'
        },
        {
          icon: 'mdi-security',
          title: 'Segurança da conta',
          route: 'redefinir-senha'
        },
        {
          icon: 'mdi-signature-text',
          title: 'Minha assinatura',
          route: 'assinatura'
        }
      ]
    }
  }
}
</script>

<style></style>
